import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import 'picturefill';
import { bindActionCreators } from 'redux';
import * as actions from '../actions';

import { resetConfigurator } from '../actions';
import SelectButtonGroup from './selectButton/SelectButtonGroup';
import ScrollIndicator from './ScrollIndicator';
import SeeResultsButton from './SeeResultsButton';

class Configurator extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { saveSelected } = this.props;
    // trigger action initially to apply conditions of first question
    saveSelected({id: undefined });
    
  }
  componentWillMount() {
    const { resetConfigurator } = this.props;
   
    resetConfigurator();
  }

  componentDidUpdate() {
    // eslint-disable-next-line no-undef
    picturefill();
  }

  render() {
    const { data, state } = this.props;

    if (!state || !state.questions || !data) {
      return null;
    }

    const { questions } = state;

    return (
      <div className="configurator">
        {questions.filter(question => question.visible).map((obj, i) => (
          <div className="configurator__question" key={i}>
            <div className="row">
              <div className="col">
                <SelectButtonGroup index={i} configData={obj} />
              </div>
            </div>
          </div>
        ))}

        <ScrollIndicator />

        <SeeResultsButton />
      </div>
    );
  }
}

Configurator.propTypes = {
  state: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  saveSelected: PropTypes.func.isRequired,
  resetConfigurator: PropTypes.func.isRequired,
};


function mapStateToProps(state) {
  return {
    state: state.configurator,
    data: state.data,
  };
}


function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({ resetConfigurator }, dispatch),
    saveSelected: (payload) => actions.saveSelected(payload)(dispatch),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Configurator);


// WEBPACK FOOTER //
// ./src/components/Configurator.js